import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  alerts: [],
  alertsMessages: [],
  news: [],
  newsId: [],
  notificationStatus: 'idle',
}

const AlertSlice = createSlice({
  name: 'alert',
  initialState,
  reducers: {
    setAlertById: (state, action) => {
      state.alerts = action.payload.alerts
    },
    setAlertMessagesById: (state, action) => {
      state.alertsMessages = action.payload.alertsMessages
    },
    addNotification: (state, action) => {
      const item = action.payload
      if (item?.id && !state.alerts.some(existing => existing.id === item.id)) state.alerts.unshift(item)
    },
    setNotificationStatus: (state, action) => {
      state.notificationStatus = action.payload
    },
    markNotificationsRead: (state, action) => {
      const ids = new Set(action.payload || [])
      state.alerts = state.alerts.filter(item => !ids.has(item.id))
    },
    addChatAlert: (state, action) => {
      const item = action.payload
      if (item?.id && !state.alertsMessages.some(existing => existing.id === item.id && existing.chat === item.chat)) state.alertsMessages.unshift(item)
    },

    setNews: (state, action) => {
      state.news = action.payload.news
    },
    setNewsId: (state, action) => {
      state.newsId = action.payload.newsId
    },
    postNewNews(state, action) {
      state.title = action.payload.title
      state.description = action.payload.description
    },
  },
})

export const {
  setAlertById,
  setNews,
  setNewsId,
  postNewNews,
  setAlertMessagesById,
  addNotification,
  setNotificationStatus,
  markNotificationsRead,
  addChatAlert,
} = AlertSlice.actions

export default AlertSlice.reducer
